// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__yE03n","info":"PatientInfo_info__14YQR"};